import { DateTime } from 'luxon';

import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';

import { NgIconComponent } from '@ng-icons/core';

import { ErrorSmallComponent } from '@components/error-handling/error-small/error-small.component';

import { ErrorStore, UserStore } from '@cxc/core/services';
import { StoreService } from '@cxc/core/services';
import { IdentityAuthAPI } from '@services/API/identity/auth.service';
import { FormService } from '@services/form.service';
import { NavigationService } from '@services/navigation.service';
import { AppConfigStore } from '@services/store/app-config.store';

import { CustomValidators } from '@cxc/core/utils';

@Component({
  selector: 'forgot-password-page',
  templateUrl: './forgot-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,

    ButtonModule,
    InputTextModule,
    RippleModule,
    FloatLabelModule,
    IconFieldModule,
    InputIconModule,
    PasswordModule,

    NgIconComponent,

    ErrorSmallComponent,
  ],
})
export class ForgotPasswordPage implements OnInit {
  formService = inject(FormService);
  errorStore = inject(ErrorStore);
  storeService = inject(StoreService);

  forgotForm!: FormGroup;

  constructor(
    public navigationService: NavigationService,

    private identityAuthAPI: IdentityAuthAPI,
    private userStore: UserStore,
    private appConfigStore: AppConfigStore,

    fb: FormBuilder
  ) {
    this.forgotForm = fb.group({
      email: ['', [CustomValidators.required(), CustomValidators.email()]],
    });
  }

  ngOnInit(): void {
    this.errorStore.clear();
  }

  submit() {
    if (this.formService.trySubmitForm(this.forgotForm)) {
      return;
    }

    this.identityAuthAPI
      .forgotPassword({ email: this.forgotForm.value['email'] })
      .subscribe({
        complete: () => {
          this.userStore.patch({ email: this.forgotForm.value['email'] });
          this.appConfigStore.patch({
            allowRoutes: { 'change-password': true },
          });
          this.storeService.add(
            'Reset-Password-Epoch',
            DateTime.now().toISO(),
            true
          );
          this.navigationService.forward('/change-password');
        },
        error: () => {
          this.errorStore.resolution.set({
            strategy: 'reload',
            url: '/forgot-password',
          });
        },
      });
  }
}
